const CHASE_FREEDOM_UNLIMITED_OFFER_ID = '84e1494c-bae2-4b0d-ac8d-e8c095ceb2fe';
const CHASE_SAPPHIRE_PREFERRED_OFFER_ID = '7dce19da-5d96-4502-9fd2-70ff9655f13a';
export const CHASE_SAPPHIRE_RESERVE_OFFER_ID = 'd89e10ed-e781-4d28-ae74-205056a10244';

export const CHASE_DIRECT_OFFER_IDS = [
  CHASE_FREEDOM_UNLIMITED_OFFER_ID,
  CHASE_SAPPHIRE_PREFERRED_OFFER_ID,
];

export const DISCOVER_IT_CASH_BACK_OFFER_ID = 'a4a36a73-0294-4ca1-b36b-3eef5cee53ca';
const DISCOVER_IT_CHROME_OFFER_ID = '3096cf68-d07e-4018-ae46-cdeb9581610f';

export const DISCOVER_DIRECT_OFFER_IDS = [
  DISCOVER_IT_CASH_BACK_OFFER_ID,
  DISCOVER_IT_CHROME_OFFER_ID,
];

export const DIRECT_TO_APPLICATION_OFFER_IDS = [
  ...CHASE_DIRECT_OFFER_IDS,
  CHASE_SAPPHIRE_RESERVE_OFFER_ID,
  ...DISCOVER_DIRECT_OFFER_IDS,
];

export const CHASE_SR_DIRECT_LINK_SLUGS = [
  // review pages
  'chase-sapphire-reserve',
];
